// extracted by mini-css-extract-plugin
export default {"confirmation_content_wrap":"Confirmation_confirmation_content_wrap__0V8N6","text_sty":"Confirmation_text_sty__MeJJC"};